/**
 * TemplateViewToggle Component
 * Toggle between grid and table view
 */

import { memo } from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ITemplateViewToggleProps } from '@/@types/messageTemplates';

function TemplateViewToggle({ viewMode, onViewModeChange }: ITemplateViewToggleProps) {
  return (
    <div className="flex items-center border border-border rounded-md overflow-hidden">
      <button
        type="button"
        onClick={() => onViewModeChange('grid')}
        className={cn(
          'p-2 transition-colors',
          viewMode === 'grid'
            ? 'bg-primary text-primary-foreground'
            : 'bg-background text-muted-foreground hover:text-foreground hover:bg-muted'
        )}
        aria-label="Grid view"
        title="Grid view"
      >
        <LayoutGrid className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => onViewModeChange('table')}
        className={cn(
          'p-2 transition-colors',
          viewMode === 'table'
            ? 'bg-primary text-primary-foreground'
            : 'bg-background text-muted-foreground hover:text-foreground hover:bg-muted'
        )}
        aria-label="Table view"
        title="Table view"
      >
        <List className="h-4 w-4" />
      </button>
    </div>
  );
}

export const TemplateViewToggleMemo = memo(TemplateViewToggle);
